var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User checked - Iconly Pro"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1193 9.83016C17.1384 10.0513 17.1484 10.2757 17.1484 10.5016C17.1484 14.5657 13.986 17.8598 10.0844 17.8598C6.18285 17.8598 3.02051 14.5657 3.02051 10.5016C3.02051 6.43821 6.18285 3.14331 10.0844 3.14331C10.3823 3.14331 10.6763 3.16319 10.9649 3.20058",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.998 5.65623L14.4429 7.16367L17.4197 4.06128",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.6123 16.9079C6.75053 15.7886 7.70664 14.5461 10.0793 14.5461C12.478 14.5461 13.4272 15.7958 13.5594 16.9286",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0947 10.4714C12.0947 11.628 11.1944 12.5659 10.084 12.5659C8.97356 12.5659 8.07324 11.628 8.07324 10.4714C8.07324 9.31475 8.97356 8.37769 10.084 8.37769C11.1944 8.37769 12.0947 9.31475 12.0947 10.4714Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserChecked);
export default __webpack_public_path__ + "static/media/user_checked.d5c46afcf1d6d5feb0bf811537569a72.svg";
export { ForwardRef as ReactComponent };